<script setup lang="ts">
import { locale } from "../../../../locale";
import {
    existSharingNotThisUser,
    selfScreenShare,
  startScreenShare,
  stopScreenShare,
} from "../../../../states/screenShareState";
import BasePopoverItem from "./BasePopoverItem.vue";
import StartShareIcon20x20 from "../../../icons/popovers/StartShareIcon20x20.vue";
import EndShareIcon20x20 from "../../../icons/popovers/EndShareIcon20x20.vue";

const props = defineProps<{
  close: () => void;
}>();

const shareAction = () => {
  if (
    selfScreenShare.value
  ) {
    stopScreenShare();
  } else if (!selfScreenShare.value && !existSharingNotThisUser()) {
    startScreenShare();
  }
  props.close();
};
</script>
<template>
  <BasePopoverItem
    :inactive="
      existSharingNotThisUser() && !selfScreenShare
    "
    :text="
      existSharingNotThisUser() && !selfScreenShare
        ? locale.alreadydemonstrate
        : selfScreenShare
          ? locale.enddemonstarate
          : locale.startdemonstarte
    "
    @click.stop="shareAction"
  >
    <StartShareIcon20x20 v-if="!selfScreenShare" />
    <EndShareIcon20x20 v-else />
  </BasePopoverItem>
</template>
<style scoped></style>
